// extracted by mini-css-extract-plugin
export default {"root":"TimeRestrictionsFoodMode_root__MnBCo","placeHolderShimmer":"TimeRestrictionsFoodMode_placeHolderShimmer__3ko9e"};